const styles = theme => ({
  bordered: {
    overflowX: 'hidden',
    border: `1px solid ${theme.palette.primary.borderColor}`,
  },
  container: {
    padding: '20px',
    border: `1px solid ${theme.palette.primary.borderColor}`,
    background: theme.palette.primary.white,
  },
  marginTop: { marginTop: '15px' },
  paperCardFrame: {
    borderRadius: '0px',
    marginBottom: '24px',
  },
  title: {
    fontWeight: '600',
    marginBottom: '5px',
  },
  titleHead: {
    background: 'none',
    color: '#342D3D',
    display: 'flex',
    alignItems: 'center',
    padding: '10px 16px',
    [theme.breakpoints.up('md')]: {
      innerCardGrid: {
        padding: '24px',
        '& h6': {
          fontSize: '1rem',
        },
      },
    },
    '& h1': {
      marginBottom: '0',
      marginRight: '8px',
      fontSize: '16px',
      '& $dangerText': {
        color: '#D2374F',
      },
      '& $textDanger': {
        color: theme.palette.primary.main,
      },
    },
    '& $textGray': {
      fontSize: '14px',
      marginTop: '6px',
    },
    '& $textRight': {
      fontSize: '20px',
      fontWeight: '600',
    },
  },
  innerCard: {
    padding: '12px 16px',
    background: theme.palette.primary.white,
    border: `1px solid ${theme.palette.primary.borderColor}`,
  },
  adgmSelect: {
    '& p': {
      maxWidth: '220px',
    },
  },
  formControl: {
    width: '100%',
    display: 'grid',
    gridTemplateColumns: '1fr',
    gap: '0',
    '& + $formControl': {
      paddingTop: '15px',
    },
  },
  calculateFeeButtonContainer: {
    display: 'flex',
    alignItems: 'flex-end',
  },
  calculateFeeButton: {
    alignSelf: 'flex-end',
    width: '100%',
    color: theme.palette.primary.main,
    fontWeight: '600',
    fontSize: '16px',
    lineHeight: '24px',
    textTransform: 'capitalize',
    padding: '14px 16px',
    border: `1px solid ${theme.palette.primary.main}`,
    borderRadius: '0px',
    '&:hover': {
      background: theme.palette.primary.adgmHover,
      color: theme.palette.primary.white,
      border: 'none',
      '& svg': {
        fill: theme.palette.primary.white,
        stroke: theme.palette.primary.white,
      },
    },
  },
  disabledCalculateFeeButton: {
    borderColor: `${theme.palette.secondary.disableLightGray} !important`,
    color: `${theme.palette.secondary.disableLightGray} !important`,
    background: `${theme.palette.primary.borderColor} !important`,
    '& svg': {
      fill: theme.palette.secondary.disableLightGray,
      stroke: theme.palette.secondary.disableLightGray,
    },
  },
  '@media (max-width:767px)': {
    paperCardFrame: {
      border: '0',
      borderRadius: '0',
    },
    titleHead: {
      flexWrap: 'wrap',
      '& $textRight': {
        fontSize: '16px',
      },
    },
    formControl: {
      gap: '16px',
    },
  },
  '@media (min-width: 768px)': {
    titleHead: {
      padding: '16px 0px',
      '& h1': {
        fontSize: '20px',
      },
    },
    formControl: {
      gap: '16px',
    },
  },
  // '@media (min-width: 992px)': {
  //   innerCard: {
  //     padding: '24px',
  //   },
  //   innerCardNoPadding: {
  //     padding: '0px',
  //   },
  //   formControl: {

  //     gridTemplateColumns: '1fr 1fr 1fr',
  //   },
  // },
  informationBanner: {
    gridColumn: '1 / -1',
    width: '100%',
    display: 'flex',
    justifyContent: 'start',
    alignItems: 'center',

    background: theme.palette.primary.infoBlueLight,
    color: theme.palette.primary.black100,
    border: `1px solid ${theme.palette.primary.main}`,
    padding: '12px',
    gap: '8px',
    borderRadius: '0px',
  },
  infoBannerText: {
    fontWeight: '400',
    fontSize: '12px',
    lineHeight: '13.92px',
    textWrap: 'wrap',
  },
  '@media (min-width: 992px)': {
    innerCard: {
      padding: '24px',
    },
    formControl: {
      display: 'grid',
      gridTemplateColumns: 'repeat(3, 1fr)',
      gap: '15px',
    },
    fullWidthField: {
      gridColumn: '1 / -1',
      width: '100%',
    },
    fullWidthContainer: {
      width: '32%',
    },
    field: {
      width: '32.5%',
      '& .MuiOutlinedInput-root': {
        borderRadius: '0px !important',
        '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
          border: '1px solid black !important',
        },
      },
      '& .MuiInputAdornment-root p': {
        marginRight: '7px',
      },
    },
    informationBanner: {
      gridColumn: '1 / -1',
      width: '100%',
      display: 'flex',
      justifyContent: 'start',
      alignItems: 'center',

      background: theme.palette.primary.infoBlueLight,
      color: theme.palette.primary.black100,
      border: `1px solid ${theme.palette.primary.main}`,
      padding: '12px',
      gap: '8px',
      borderRadius: '0px',
    },
    infoBannerText: {
      fontWeight: '400',
      fontSize: '12px',
      lineHeight: '13.92px',
      textWrap: 'wrap',
    },
    // calculateFeeButtonContainer: {
    //   gridColumn: '2 / 4', // Positions button in the final two columns on last row
    //   textAlign: 'center',
    // },

    divider: {
      margin: '24px 0px',
    },
  },
});

export default styles;
